"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFormat_yyyyMMDDTHHmmssZ = void 0;
const ts_common_1 = require("@nu-art/ts-common");
exports.DateTimeFormat_yyyyMMDDTHHmmssZ = (0, ts_common_1.DateTimeFormat)('YYYY-MM-DDTHH:mm:ssZ');
